<template>
  <modal-auth modal-type="resetPassword" :data="data">
    <h5 class="text-center">{{$t('setPassword')}}</h5>
    <br>
    <input v-if="isLogin" type="password" class="form-control" :placeholder="$t('oldPassword')" v-model="password" required/>
    <input v-if="!isLogin" type="password" class="form-control" :placeholder="$t('password')" v-model="password" required/>
    <br>
    <input v-if="isLogin" type="password" class="form-control" :placeholder="$t('newPassword')" v-model="passwordConfirm" required/>
    <input v-if="!isLogin" type="password" class="form-control" :placeholder="$t('passwordConfirmation')" v-model="passwordConfirm" required/>
    <br>
    <p class="text-center">
      <button v-if="!isLoading" class="btn btn-fill btn-danger btn-round btn-sm btn-wd">{{$t('send')}}</button>
      <sync-loader v-if="isLoading" class="text-center" color="red"></sync-loader>
    </p>
   </modal-auth>
</template>

<script>
  import ModalAuth from '../components/ModalAuth'
  import { mapGetters } from 'vuex';
  import syncLoader from 'vue-spinner/src/PulseLoader.vue'

  export default {
    created() {
      if(!this.data.access_token) this.$router.push({name: 'login'})
    },
    props: {
      access_token: {type: String, default: null}
    },
    data() {
      return {
        password: '',
        passwordConfirm: ''
      }
    },
    computed: {
      ...mapGetters(['isLoading', 'isLogin', 'getAccessToken']),
      data() {
        return {
          password: this.password,
          passwordConfirm: this.passwordConfirm,
          access_token: this.isLogin ? this.getAccessToken : this.access_token
        }
      }
    },
    components: { ModalAuth, syncLoader }
  }
</script>
